import { createContext, useContext } from 'react';

import { DEFAULT_LOCALE, type Locale } from './i18n';

// The active UI language + a setter, provided once at the top of the app
// (`_app.tsx`) and consumed by the Settings language picker. The setter both
// switches the live locale (re-renders every `useTranslation` consumer via
// `activateLocale`) AND persists the choice, so it sticks across reloads. Kept a
// separate tiny context rather than lifting state through props because the
// picker lives many levels down, on a different page than where the state lives.
export type LocaleContextValue = {
  locale: Locale;
  setLocale: (locale: Locale) => void;
};

export const LocaleContext = createContext<LocaleContextValue>({
  locale: DEFAULT_LOCALE,
  setLocale: () => {},
});

export function useLocale(): LocaleContextValue {
  return useContext(LocaleContext);
}
